<template>
  <section class="i-final-cta">
    <div class="container">
      <h2 class="final-cta__display">Your results are<br /><em>waiting on a plan.</em></h2>
      <p>
        {{ timing }} minutes. A former recruiter who's seen 10,000 careers from the inside. A written plan you leave
        with. The median return: $25,400. Normally ${{ highPricing }} — today: ${{ pricing }}.
      </p>
      <a
        class="btn-primary"
        href="#book"
        @click.prevent="$emit('book')"
      >
        Book your session — <span class="final-cta__was">${{ highPricing }}</span> ${{ pricing }}
      </a>
      <div
        v-if="!paymentProcessing"
        class="scarcity-line scarcity"
        @click="$emit('skip')"
      >
        No thanks - I'm fine figuring it out the hard way
      </div>
      <div class="scarcity-line">
        11 slots remaining this week. <strong>Sessions are first-come, first-served.</strong>
      </div>
      <div class="no-upsell-line">No upsell. No subscription. One conversation. Done.</div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineEmits(["book", "skip"])

// PROPS
defineProps({
  pricing: {
    type: String,
    default: "49"
  },
  timing: {
    type: String,
    default: "30"
  },
  highPricing: {
    type: String,
    default: "149.90"
  },
  paymentProcessing: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.i-final-cta {
  background: var(--navy-mid);
  padding: 80px 0;
  text-align: center;
  border-top: none;

  p {
    color: #f7f4ef8c;
    max-width: 520px;
    margin: 0 auto 36px;
    font-size: 0.95rem;
    line-height: 1.7;
  }

  .final-cta {
    &__display {
      font-size: clamp(28px, 5vw, 44px);
      font-weight: 800;
      color: #f7f4ef;
      margin-bottom: 16px;
      line-height: 1.15;
      letter-spacing: -0.02em;

      em {
        font-family: "DM Serif Display", serif;
        font-style: italic;
        color: var(--purple-lt);
        font-weight: 400;
      }
    }

    &__was {
      text-decoration: line-through;
      opacity: 0.5;
    }
  }

  .scarcity {
    margin-top: 5px;
    text-decoration: underline;

    &:hover {
      cursor: pointer;
      color: #f7f4efa0;
    }
  }

  // override global scarcity/no-upsell colours for dark bg
  :deep(.scarcity-line) {
    color: #f7f4ef66;
  }

  :deep(.scarcity-line strong) {
    color: #f0a0a0;
  }

  :deep(.no-upsell-line) {
    color: #f7f4ef4d;
  }
}
</style>
